import type { ContactAreaFeatureConfig } from './type';

export const base: ContactAreaFeatureConfig = {
    showSupportChatSection: true,
};
